import React, { useMemo } from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import { capitalizarNombre } from '../Helpers/utilidades-globales'

const filtrarOpciones = createFilterOptions({ limit: 300 })

const estiloCampo = {
    '& .MuiAutocomplete-inputRoot': {
        height: '2.25rem',
        minHeight: '2.25rem',
        padding: '0 32px 0 9px !important',
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        fontSize: '0.875rem'
    },
    '& .MuiAutocomplete-inputRoot input.MuiAutocomplete-input': {
        padding: '0 !important',
        height: 'auto',
        lineHeight: 1.5
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C2C1C1',
        borderWidth: '1.5px'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#9E9E9E'
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#607D8B',
        borderWidth: '1.5px'
    },
    '& .Mui-disabled .MuiAutocomplete-inputRoot, & .MuiAutocomplete-inputRoot.Mui-disabled': {
        backgroundColor: '#F5F5F5',
        cursor: 'not-allowed'
    }
}

export default function SelectorObreroTypeahead({obreros, value, onChange, disabled, placeholder, titulo}){
    const opciones = useMemo(
        () => obreros.map(item => ({ id: item.id_obrero, label: capitalizarNombre(item.nom_simple) })),
        [obreros]
    )

    const seleccionado = useMemo(
        () => opciones.find(opcion => String(opcion.id) === String(value)) || null,
        [opciones, value]
    )

    return <Autocomplete
        disablePortal
        fullWidth
        size="small"
        autoHighlight
        selectOnFocus
        handleHomeEndKeys
        disabled={disabled}
        title={titulo}
        options={opciones}
        value={seleccionado}
        filterOptions={filtrarOpciones}
        noOptionsText="No se encontraron ministros"
        isOptionEqualToValue={(opcion, valor) => opcion.id === valor.id}
        onChange={(event, nuevoValor) => onChange(nuevoValor ? nuevoValor.id : null)}
        sx={estiloCampo}
        renderInput={(params) => <TextField {...params} placeholder={placeholder || 'Buscar un ministro...'} />}
    />
}
